import React from 'react';
import __ from 'lodash';
import {Link} from 'react-router-dom';
import DropdownReset from './DropdownReset'
import { CONFIG, CONFIG_UTIL } from '../../../../config';
import utilManagement from '../../../../apis/utilManagement';
import accountManagement from '../../../../apis/accountManagement';
import SiswaKelasParalel from '../../../../entity/SiswaKelasParalel';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import {Alert,Row,Col,Modal} from 'react-bootstrap';
import LoaderModal from '../../../modal/LoaderModal';

class ListTableSiswa extends React.Component{
    state = {
        idKelasParalel: '',
        idSiswa:'',
        selectedIdSiswa:null,
        value: {},
        mapel: {},
        openDialog: false,
        openCbtReset: false,
        openModalGantiPassword : false,
        listCbt: [],
        listMapel: [],
        siswaSelected: {},
        alertShow: false,
        alertMessage: '',
        password: null
    };    

    dropdownResetOnChange  = async (value) =>{        
        const aksi = value.split('-')[0];   
        const idSiswa = value.split('-')[1];  

        if(aksi=="rPassword"){            
            this.setState({
                openDialog: true,
                value: {...value, ['idSiswa']: idSiswa, ['nama']: value.split('-')[2], ['aksi']: 'Reset Password'}
            })
        }
        else if(aksi=="rHomework"){
            this.setState({ 
                value: {...value, ['idSiswa']: idSiswa, ['nama']: value.split('-')[2], ['aksi']: 'Reset Homework', ['tipe']: 'HW'}
            })
            this.fetchCbtSiswa(idSiswa, 'HW');     
        } 
        else if(aksi=="rExam"){
            this.setState({ 
                value: {...value, ['idSiswa']: idSiswa, ['nama']: value.split('-')[2], ['aksi']: 'Reset Exam', ['tipe']: 'EXAM'}
            })
            this.fetchCbtSiswa(idSiswa, 'EXAM');    
        } 
        else if(aksi=="gantiPassword"){
            this.setState({ 
                value: {...value, ['idSiswa']: idSiswa, ['nama']: value.split('-')[2], ['aksi']: 'Ganti Password'},
                openModalGantiPassword : true
            })   
        } 
    }

    fetchCbtSiswa = async(idSiswa, tipe) => {
        this.setState({ isFetching: true })        
        const response = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_CBT_SISWA + idSiswa + '/' + tipe )
        .catch (function(error){ alert(error)})
        if(response){
            this.setState({
                openCbtReset: true,    
                listCbt: response.data.data,
                isFetching: false
            })
        }
    }

    renderCbtSiswa() {
        const {value, listCbt, listMapel} = this.state;
        const handleClose = () => { 
            this.setState({
                openCbtReset: false,
                value: {},
                mapel: {},
                listCbt: [],
                listMapel:[]
            }) 
        };
        return (
            <>                
                <Col sm={6}>
                    <strong>{value.aksi} {value.nama}</strong> <br/>
                    <div className="form-group">
                        <select className="form-control" onChange={this.onChangeCbt}>
                            <option value="0">Pilih Cbt</option>
                            {listCbt.map((cbt, i) => 
                            <option value={cbt.idHeader}>{cbt.namaJadwal}</option>
                            )}
                        </select>
                    </div>
                </Col>

                <Col>
                    <table className="table">
                        <thead>
                            <th width='10px'>No</th>
                            <th>Mata Pelajaran</th>
                            <th width="20%" className="text-center">Status Pengerjaan</th>
                            <th width="10%">#</th>
                        </thead>
                        <tbody>
                            {listMapel.map((mapel, i) => 
                                <tr key={i}>
                                    <td>{i+1}.</td>
                                    <td>{mapel.namaMapel}</td>
                                    <td className="text-center">
                                        {mapel.statusPengerjaan === 1 ? <i className="fa fa-check text-success"></i> : <i className="fa fa-remove text-danger"></i>}
                                    </td>
                                    <td><button className="btn btn-outline-primary" onClick={(e) => this.showDialog(e,mapel)}>reset</button></td>
                                </tr>
                            )}                            
                        </tbody>
                    </table>
                </Col>

                <Col>
                    <button className="btn btn-danger" onClick={handleClose}>Batal</button>
                </Col>
            </>
        )
    }

    onChangeCbt = async(e) => {
        this.setState({ isFetching: true, listMapel: []})        
        const response = await accountManagement.get(CONFIG.ACCOUNT_MANAGEMENT_GET_CBT_MAPEL_SISWA + e.target.value )
            .catch (function(error){ alert(error)})
            if(response){
                this.setState({
                    listMapel: response.data.data,
                    isFetching: false
                })
            }
    }

    showDialog = (e,data) => {   
        console.log(data)       
        this.setState({ 
            openDialog: true,
            mapel: data
        })
        
    }

    resetPassword() {
        this.setState({openDialog:false})
        this.props.resetPassword(this.state.value.idSiswa)
    }    

    resetCbt = async() => {
        this.setState({isFetching: true, openDialog:false});
        const {mapel, listMapel, siswaSelected} = this.state;

        // Eksekusi Reset Status
        const response = await accountManagement.post(CONFIG.ACCOUNT_MANAGEMENT_RESET_CBT_SISWA, mapel.idSubHeader)
        .catch (function(error){ alert(error) })
        if(response){
            this.setState({
                mapel: {} ,
                alertShow: true,
                alertMessage: response.data.errorSchema.errorMessage
            });
            this.setState(prev => ({
                ...prev,
                listMapel: this.state.listMapel.map(item =>
                  item.idSubHeader === mapel.idSubHeader ? { ...item, statusPengerjaan: 0 } : { ...item }
                )
            }));
        }

        // Eksekusi Reset Timer
        const eksReset = await utilManagement.delete(CONFIG_UTIL.UTIL_RESET_TIMER_SISWA+mapel.idProfilCbt+'/'+mapel.idSubProfil+'/'+siswaSelected.idSiswa+'/123')
        .catch(function(error) {
            console.log('kelas error '+error)
        });

        this.setState({isFetching: false});
    }

    confirmDialog() {
        //onClick={() => this.showDialog(jadwal)}
        const {openDialog, value, mapel} = this.state;    
        
        let content, button;
        if(!__.isEmpty(mapel)) {           
            content = <DialogContentText id="alert-dialog-description">                        
                        Yakin akan reset <strong>{mapel.namaMapel}</strong> <br/>
                        siswa <strong>{value.nama}</strong> ?
                    </DialogContentText>
            button = <button className="btn btn-primary" onClick={() => this.resetCbt()} autoFocus> Ya </button>     
        } else {
            content = <DialogContentText id="alert-dialog-description">                        
                        Yakin akan {value.aksi} siswa <strong>{value.nama}</strong> <br/>
                        ke default <strong>123456</strong> ?
                    </DialogContentText>
            button = <button className="btn btn-primary" onClick={() => this.resetPassword()} autoFocus> Ya </button>     
                   
        }
        const handleClose = () => { this.setState({openDialog: false}) };        
        return (
            <>
            <Dialog
                open={openDialog}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
            >
                <DialogTitle id="alert-dialog-title">{value.aksi}?</DialogTitle>
                <DialogContent>
                    {content}
                </DialogContent>
                <DialogActions>
                    <button className="btn btn-danger" onClick={handleClose}> Tidak </button>
                    {button}               
                </DialogActions>
            </Dialog>
            </>
        )
    }

    doSiswaSelected = async (siswaSelected) => {
        this.setState({
            siswaSelected: siswaSelected
        })
    }

    renderListSiswa(){
        if(!__.isEmpty(this.props.listSiswa)){
            return this.props.listSiswa.map((siswa,i) => {
                return (
                    <tr key={siswa.idSiswa}>
                        <td>{i+1}</td>
                        <td>{siswa.kodeTahunAjaran}</td>
                        <td>{siswa.username}</td>
                        <td>{siswa.namaSiswa}</td>
                        <td>{siswa.telponSiswa}</td>
                        <td>{siswa.emailSiswa}</td>
                        <td>
                            <Link to={{ pathname: '/cetakuser/'+siswa.idSiswa}} target="_blank">
                                <button className="btn btn-primary btn-cetak"><li className="fa fa-print"></li></button>
                            </Link>
                        </td>
                        <td>
                            <DropdownReset reset={siswa} onChange={this.dropdownResetOnChange} doSiswaSelected={this.doSiswaSelected}/> 
                        </td>
                    </tr>
                )
            })
        }else{
            return (
                <tr>
                    <td colSpan="8">Tidak Ada Siswa</td>
                </tr>
            )
        }        
    }

    render(){
        return(            
            <div>
                <LoaderModal isFetching={this.state.isFetching} />
                {this.loadAlert()} 
                {this.state.openCbtReset ? this.renderCbtSiswa() :
                <div className="col-md-12">
                    <table className="table table-striped" id="myTable">
                        <thead>
                            <tr>
                                <th>No</th>
                                <th>Thn Ajaran</th>
                                <th>Username</th>
                                <th>Nama Siswa</th>
                                <th>No Telp</th>
                                <th>Email</th>
                                <th>Cetak Akun</th>
                                <th>#</th>
                            </tr>
                        </thead>
                        <tbody>
                            {this.renderListSiswa()}
                        </tbody>
                    </table>                    
                </div>
                }
                {this.confirmDialog()}
                {this.renderModalGantiPassword()}
            </div>            
        )
    }

    onChangeUniversal =  async (e)=>{
        this.setState({ [e.target.name]: e.target.value}  );
    }


    handleSubmitGantiPassword = async (e) =>{
        this.setState({
            openModalGantiPassword: false,
            isFetching : true
        });
        e.preventDefault();

        let data={
            'idSiswa' : this.state.value.idSiswa,
            'password': this.state.password
        }

        const response = await accountManagement.post(CONFIG.GANTI_PASSWORD_MANUAL, data)
        .catch (function(error){ alert(error) })
        if(response){
            this.setState({
                alertShow: true,
                alertMessage: response.data.errorSchema.errorMessage
            });
        }
        this.setState({isFetching : false});
    }

    renderModalGantiPassword(){
        return(
            <Modal
            show={this.state.openModalGantiPassword}
                onHide={() => this.setState({ openModalGantiPassword: false })}
                aria-labelledby="example-custom-modal-styling-title"
                size="lg" backdrop="static" keyboard={false}>
                <Modal.Header closeButton>
                    <Modal.Title>Ganti Password {this.state.value.nama}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form onSubmit={this.handleSubmitGantiPassword}>
                        <Row>
                            <Col sm={3}><label><span className="text-danger">*</span>Password Baru</label></Col>
                            <Col sm={9}>
                                <input 
                                    title="Password Baru" placeholder="min 6 karakter" className="form-control" required minLength="6"
                                    id="password" name="password" onChange={this.onChangeUniversal}
                                />
                            </Col>
                        </Row>
                        <Row style={{"float": "right", "padding":"15px"}}>
                                <button type="submit" value="Submit" className="btn btn-primary">
                                    <li className="fa fa-reset"> Ganti</li>
                                </button>
                        </Row>
                    </form>
                </Modal.Body>
            </Modal>
        )
    }

    loadAlert = () => {
        const {alertShow, alertMessage } = this.state;
      
        if (alertShow) {
          return (
            <Alert variant="info" onClose={() => this.setState({ alertShow: false })} dismissible>   
                <strong>{alertMessage}</strong>
            </Alert>
          );
        } 
    }
}


export default ListTableSiswa;